export const ACTIVE_EVENTS_REPORT_ID = 'active-events';
